import Swiper from "swiper";
import { Navigation, Pagination, EffectCreative } from "swiper/modules";

const reviewsSwiper = document.querySelector(".reviews-swiper");

if (reviewsSwiper) {
  new Swiper(reviewsSwiper, {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: reviewsSwiper.querySelector(".swiper-pagination"),
      clickable: true,
    },
    navigation: {
      nextEl: reviewsSwiper.querySelector(".swiper-button-next"),
      prevEl: reviewsSwiper.querySelector(".swiper-button-prev"),
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
      1320: {
        spaceBetween: 50,
        slidesPerView: 4,
      },
    },
  });
}

const shopHeaderSlider = document.querySelector(".shop-header-slider-wrap");

if (shopHeaderSlider) {
  new Swiper(shopHeaderSlider.querySelector('.swiper'), {
    modules: [Navigation],
    slidesPerView: 2,
    spaceBetween: 10,
    navigation: {
      nextEl: shopHeaderSlider.querySelector(".swiper-button-next"),
      prevEl: shopHeaderSlider.querySelector(".swiper-button-prev"),
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  });
}



const review_form_wrapper = document.getElementById("review_form_wrapper");
const writeReviewBtn = document.getElementById("write-review-btn");
const reviewsListWrapper = document.getElementById("reviews-list-wrapper");
const cancelReviewBtn = document.getElementById("cancel-review-btn");
if (writeReviewBtn && review_form_wrapper) {
 writeReviewBtn
    .addEventListener("click", function (e) {
      e.preventDefault();
      reviewsListWrapper.style.display = 'none';
      review_form_wrapper.style.display = 'block';
    });
 cancelReviewBtn
    .addEventListener("click", function (e) {
      e.preventDefault();
      review_form_wrapper.style.display = 'none';
      reviewsListWrapper.style.display = 'block';
      
    });
}
